import { Modal, Button } from "rsuite";
import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { Check } from "lucide-react";

const ProductSaveModal = ({ open, onClose }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  setTimeout(() => navigate("/dashboard"), 2000);

  const handleGoHome = () => {
    onClose();
    navigate("/dashboard");
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      size="xs"
      keyboard={false}
      backdrop="static"
    >
      <motion.div
        initial={{ scale: 0.8, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ duration: 0.3 }}
        className="text-center p-5"
      >
        {/* Success Icon */}
        <div className="mb-4">
          <div
            className="rounded-circle d-flex align-items-center justify-content-center mx-auto mb-3"
            style={{
              width: "80px",
              height: "80px",
              backgroundColor: "#FFDB80",
              fontSize: "2.5rem",
            }}
          >
            <Check size={40} color="#8077EC" />
          </div>
        </div>

        <h4 className="mb-3 fw-bold text-dark">
          <>{t("progress_saved_successfully")}</>
        </h4>

        <p className="mb-4 text-muted">{t("what_would_you_like_to_do")}</p>

        <div className="d-grid gap-3">
          <Button
            appearance="default"
            block
            onClick={handleGoHome}
            className="btn-lg fw-semibold py-3"
            style={{
              backgroundColor: "#FFDB80",
              borderColor: "#FFDB80",
              color: "#8077EC",
            }}
          >
            {t("go_home")}
          </Button>
        </div>
      </motion.div>
    </Modal>
  );
};

export default ProductSaveModal;
